import WriteToLog from "./WriteToLog";
import axios from "axios";

/**
 * Request an authorization code from Epic
 * @param {*} data req.query passed by Hyperdrive when app is launched from Hyperdrive
 * req.query = {
 *   "iss":"https://...../fhir-test/api/FHIR/R4",
 *   "launch":"eyJhbGciOiJSUzI1N......"
 * }
 */
async function getOAuthCode(data) {
  let oauth2_authorize_uri = data.oauth2_authorize_uri;
  let fhir_server = data.iss.substr(0, data.iss.indexOf('api'));
  //WriteToLog("getOAuthCode function FHIR SERVER: " + fhir_server);
  const ehrconfig = await axios.get('ehrconfig.json');
  let config = ehrconfig.data[fhir_server];

  try {
    let oauth2_authorize_url = [oauth2_authorize_uri, 
      '?scope=launch&response_type=code', 
      '&redirect_uri=', encodeURIComponent(config['PICU_REDIRECT']),
      '&client_id=', config['PICU_CLIENT_ID'],
      '&launch=', data.launch, 
      '&state=', encodeURIComponent(data.oauth2_token_uri), '*' , fhir_server,
      '&aud=', encodeURIComponent(data.iss)].join('');
    //WriteToLog("getOAuthCode function OAuth2 Authorize URL: " + oauth2_authorize_url);

    // Redirect to Epic OAuth Authorize URL
    window.location.assign(oauth2_authorize_url);
  }
  catch(e) {
    WriteToLog("getOAuthCode function error: " + e.message);
    throw new Error(' GetOAuthCode error:' + e.message);
  }
};

export default getOAuthCode;
